import React from 'react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import states from './states.json'

import { FormControl } from '@/components/ui/form'

interface Props {
  onChange: (value: string) => void
  value: string
  placeholder?: React.ReactNode
  className?: string
}

export function StatesDropdown({
  onChange,
  value,
  placeholder = '',
  className,
}: Props) {
  return (
    <Select onValueChange={onChange} value={value}>
      <FormControl>
        <SelectTrigger className={className}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        {states.map((state) => (
          <SelectItem key={state.code} value={state.code}>
            {state.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
